export enum SweepError {
  ManagedPackageRequired,
  ProductionEnvMissing,
  CrmOrgNotFound,
  CrmOrgBadCredentials,
  CrmOrgLockTimeout, // Deprecated
  UserNotConnected,
  SfdcUserBadCredentials,
  SfdcUserNoCredentialsYet,
  NoFieldPermission,
  HubspotNoCredentials,
  CrmOrgInvalidGrant,
  CustomIntegrationInUse,
  RequestLimitExceededTotalRequests,
  RequestLimitExceededConcurrentRequests,
}

export type EnvConnectionError = {
  crmOrgId: string;
  error: SweepError.CrmOrgBadCredentials | SweepError.CrmOrgNotFound;
};
